<template>
	<transition name="slide-down">
		<div v-if="show" class="filter-list">
			<div class="filter-list__wrapper">
				<div class="grid-container">
					<div class="grid-x grid-margin-x">
						<div class="cell small-12 medium-12 large-12">
							<div class="filter-list__category-list">
								<div
									class="filter-list__category"
									v-for="(filters, i) in filterCategorys"
									:key="i"
								>
									<div class="filter-list__label" v-if="labels[i]">
										<span>{{ labels[i] ? labels[i] : '' }}</span>
										<div
											class="filter-list__info"
											v-if="filters[0].type == 'activitylevel'"
										>
											<Tooltip
												size="small"
												:title="$t('skischool.levelsTooltipTitle')"
												:text="[
													$t('skischool.level2048Tooltip'),
													$t('skischool.level2049Tooltip'),
													$t('skischool.level2050Tooltip'),
													$t('skischool.level2051Tooltip'),
													$t('skischool.level2063Tooltip')
												]"
											/>
										</div>
									</div>
									<div class="filter-list__checkboxes">
										<CheckboxButton
											v-for="filter in filters"
											@click-input="toggleFilter(filter)"
											:key="filter.id"
											:id="filter.id"
											:checked="checkIfInList(filter)"
											:value="filter.label"
											:description="filter.description"
											:type="filter.type"
											:isDisabled="false"
										/>
									</div>
								</div>

								<Button
									class="filter-list__clear"
									size="xsmall"
									color="primary6"
									@click.native="clearFilter()"
								>
									{{ $t('skipass.clearFilters') }}
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Button from '../atoms/Button.vue'
import CheckboxButton from '../atoms/CheckboxButton.vue'
import Tooltip from '../molecules/Tooltip'

import store from '../../vueX/store'

export default {
	name: 'FilterList',
	components: {
		CheckboxButton,
		Button,
		Tooltip
	},
	props: {
		filterCategorys: {
			type: Array
		},
		// selectedFilters:{
		//   type: Array,
		// },
		labels: {
			type: Array
		},
		show: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			hidden: false,
			array: []
		}
	},
	computed: {
		selectedFilters() {
			return store.state.productList.selectedFilters
		}
	},
	methods: {
		toggleFilter(filter) {
			const newSelectedFilters = [...this.selectedFilters]
			let index = null

			const array = newSelectedFilters.filter((each, i) => {
				if (each.id == filter.id && each.type == filter.type) {
					index = i
					return true
				}
				return false
			})

			if (array.length) {
				newSelectedFilters.splice(index, 1)
			} else {
				newSelectedFilters.push(filter)
			}

			store.dispatch('PRODUCT_SELECTED_FILTERS', newSelectedFilters)

			// this.$emit('bubbel-selected-filters', newSelectedFilters)
		},
		checkIfInList(filter) {
			return (
				this.selectedFilters.findIndex(
					each => each.id == filter.id && each.type == filter.type
				) > -1
			)
		},
		clearFilter() {
			store.dispatch('PRODUCT_SELECTED_FILTERS', [])
			// this.$emit('bubbel-selected-filters', [])
		}
	}
}
</script>

<style scoped lang="scss">
.filter-list {
	&__wrapper {
		background: #f4f5f7;
		padding: 40px 0 0;
		background: $colorPrimary1;
		padding: 25px 0 29px;
		.checkbox-button {
			vertical-align: middle;
		}
	}
	&__label {
		font-size: 15px;
		margin-bottom: 5px;
		color: $colorPrimary7;
		> span {
			vertical-align: middle;
		}
	}
	&__info {
		display: inline-block;
		vertical-align: middle;
		margin-top: -2px;
	}
	&__clear {
		//margin-left: auto;
		//margin-bottom: 2px;
		margin: 20px 0 0 auto;
		@include for-tablet-portrait-up {
			margin: 0 0 2px auto;
		}
	}
	&__category-list {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
	}
	&__category {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		margin: 10px 0 0 0;
		@include for-tablet-landscape-up {
			margin: 10px 0 0 14px;
		}
		&:first-child {
			margin-left: 0;
		}
	}
	&__checkboxes {
		display: flex;
		flex-wrap: wrap;
		@include for-tablet-portrait-up {
			flex-wrap: nowrap;
		}
	}
}
</style>
